export const ZapFieldMapping = "zapFieldMapping";
export const BuildZapSkeleton = "buildZapSkeleton";
export const InterfaceSetup = "interfaceSetup";
export const TablesOperations = "tablesOperations";
export const AuthenticationOperations = "authenticationOperations";

export interface RawRecipeData {
  id:
    | typeof ZapFieldMapping
    | typeof BuildZapSkeleton
    | typeof InterfaceSetup
    | typeof TablesOperations
    | typeof AuthenticationOperations;
  description: string;
  keywords: string[];
}

// Raw recipe data is the baseline text-based recipe data that does not include associated tools.
export const rawRecipeData: RawRecipeData[] = [
  {
    id: ZapFieldMapping,
    description:
      "Configure and map fields in existing Zapier workflows. This recipe helps with setting up field mappings between different steps in a Zap, handling authentication, parameter configuration, and connecting data from triggers to actions. Use this when you need to configure how data flows between different apps in a Zap automation, set up field references using the {{step_id__new__data__fX}} format, or troubleshoot field mapping issues.",
    keywords: [
      "field mapping",
      "zap configuration",
      "parameter setup",
      "data mapping",
      "workflow configuration",
      "field references",
      "authentication",
      "step configuration",
      "zap parameters",
      "data flow",
      "field connections",
      "automation setup",
      "zapier fields",
      "configure zap",
      "map fields",
      "connect data",
      "field format",
      "step references",
      "zap recipes",
      "setup zap",
      "turn on zap",
    ],
  },
  {
    id: BuildZapSkeleton,
    description:
      "Create the initial structure and skeleton for new Zapier workflows. This recipe provides the foundation for building new Zaps by setting up the basic workflow structure with triggers and actions, configuring app implementations, and establishing the proper ZAP schema format. Use this when you need to create a new automation workflow from scratch, set up the basic Zap structure with empty parameters, or establish the initial framework before field mapping.",
    keywords: [
      "create zap",
      "build zap",
      "zap creation",
      "workflow creation",
      "new automation",
      "zap skeleton",
      "zap structure",
      "workflow setup",
      "automation framework",
      "zap schema",
      "initial setup",
      "workflow foundation",
      "trigger setup",
      "action setup",
      "app implementation",
      "automation creation",
      "workflow building",
      "zap template",
      "zap recipes",
    ],
  },
  {
    id: InterfaceSetup,
    description:
      "Comprehensive guide for Zapier Interfaces creation and management workflows. This recipe provides detailed guidance for creating interfaces, managing pages, working with interface APIs, handling interface limits, setting up forms, configuring user interactions, and implementing interface best practices. Use this when creating interfaces, managing interface pages, working with interface configurations, setting up interface from table workflows, or implementing any interface operations.",
    keywords: [
      "interfaces",
      "interface creation",
      "interface setup",
      "interface configuration",
      "interface management",
      "interface pages",
      "interface operations",
      "interface workflows",
      "interface from table",
      "interface limits",
      "interface api",
      "interface endpoints",
      "page creation",
      "page management",
      "form setup",
      "form creation",
      "form configuration",
      "user interface",
      "ui interfaces",
      "web interfaces",
      "interface design",
      "user interaction",
      "interface patterns",
      "interface development",
      "interface best practices",
      "ui setup",
      "interface recipes",
      "create interface",
      "interface builder",
      "interface templates",
      "interface deployment",
      "interface publishing",
      "edit interface",
      "update interface",
    ],
  },
  {
    id: TablesOperations,
    description:
      "Comprehensive guide for Tables operations and workflows. This recipe provides specific guidance for creating, managing, and working with Zapier Tables, including field management, record operations, usage limits, and best practices. Use this when creating tables, managing table data, checking table limits, or performing any table-related operations.",
    keywords: [
      "tables",
      "table creation",
      "table management",
      "table fields",
      "table records",
      "table data",
      "table limits",
      "table usage",
      "table operations",
      "database",
      "data storage",
      "record management",
      "table configuration",
      "table api",
      "table endpoints",
      "table workflows",
      "table best practices",
      "create table",
      "build table",
      "make table",
      "update table",
    ],
  },
  {
    id: AuthenticationOperations,
    description:
      "Authentication workflows and troubleshooting guide for Zapier applications. This recipe provides specific guidance for checking authentication status, handling authentication errors, working with different auth types, troubleshooting connection issues, and implementing authentication best practices. Use this when dealing with authentication errors, checking auth status, troubleshooting connections, or working with app authentication workflows.",
    keywords: [
      "authentication",
      "auth check",
      "authentication status",
      "auth errors",
      "connection issues",
      "auth troubleshooting",
      "authentication workflows",
      "auth operations",
      "app authentication",
      "auth configuration",
      "authentication apis",
      "auth verification",
      "connection setup",
      "auth best practices",
      "authentication debugging",
      "auth management",
      "user authentication",
      "auth tokens",
      "app connection",
    ],
  },
];
